import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{body-class \"tags-page\"}}\n{{outlet}}",{ moduleName: "discourse/templates/tags.hbs" })